import api from '@/services/api'



export default () =>
  new Promise((resolve, reject) => {
    api()({
      url: `catalog/getProductGroupNames${
        localStorage?.getItem('lang')
          ? `?lang=${localStorage.getItem('lang').toUpperCase()}`
          : ''
      }`
    })
      .then(e => resolve(e.data?.data))
      .catch(() => reject(false));
  });
